import _ from "lodash";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_TimesheetWeekLog,
  GET_TimesheetWeek,
  POST_TimesheetEntry,
} from "../services/Timesheet";
import exception from "../utils/exception";
import { jwtDecode } from "../utils/jwt";
import { getToken } from "../utils/token";

/**
 * 動作名稱與 reducer 的 key 都還是 Week（SAVE_TimesheetWeek → state.Timesheet.Week），
 * 但拿的已經是「每天記了什麼」那一包 —— reducers/Timesheet.js 不在這次能改的範圍內，
 * 為了一個名字去動 reducer 只會多一個要一起改的地方。
 *
 * 為什麼要試兩支：後端同時在做，還沒定案是擴充 /Timesheet/Week 還是新開
 * /Timesheet/WeekLog。兩支參數一樣，先打新的，端點不存在（404／405）才退回舊的，
 * 兩種決定都不必再改前端。其餘錯誤（403 沒權限、500）照常走 exception 跳提示 ——
 * 一律 fallback 會把「你沒有權限看這個人」吞成一張空白的週表。
 */
function* GET_TimesheetWeekEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);

    let res;
    try {
      res = yield call(GET_TimesheetWeekLog, token, payload);
    } catch (error) {
      const status = _.get(error, "response.status");
      if (status !== 404 && status !== 405) throw error;
      res = yield call(GET_TimesheetWeek, token, payload);
    }

    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_TimesheetWeek", payload: resData.data });
    if (callback) callback(resData.data);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

/** 登記工時。目前沒有畫面在用（見 services/Timesheet.js 的說明），先留著不刪 */
function* POST_TimesheetEntryEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(POST_TimesheetEntry, token, payload);
    if (res) { /* 無需解碼 */ }
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

/*
 * 「工時送審」整支拿掉了（原本的 POST_TimesheetSubmit → POST /Timesheet/Submit）。
 *
 * 查過後端：TimesheetService.Submit 只在 timesheet 這張表寫一列
 * （period_start／period_end／status=1／submitted_at），而整個 api/Web 裡
 * 沒有任何地方再讀 timesheet 這張表 —— 沒有審核清單、沒有通知、沒有統計。
 * 按下去唯一會發生的事就是跳一句「已送出工時審核」，而沒有人會收到。
 * 這一頁又不再填時數，留著一顆送不到任何人手上的鈕就是在騙人。
 */

export default function* TimesheetSaga() {
  yield takeLatest("GET_TimesheetWeek", GET_TimesheetWeekEffect);
  yield takeLatest("POST_TimesheetEntry", POST_TimesheetEntryEffect);
}
